import React from "react"
import { Button, AppBar, Toolbar, Typography } from "@mui/material"
import styles from "../styles/Header.module.scss"
import GoogleIcon from "@mui/icons-material/Google"

const Header = ({ admin, signInWithGoogle }) => {
  return (
    <AppBar position="static" color="primary" className={styles.header}>
      <Toolbar className={styles.toolbar}>
        <Typography variant="h6">Live Q&A</Typography>
        {!admin ? (
          <Button
            color="inherit"
            onClick={signInWithGoogle}
            startIcon={<GoogleIcon />}
          ></Button>
        ) : (
          <Typography variant="body1">Admin</Typography>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Header
